import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext';

/**
 * Защищённый маршрут.
 * @param {React.ReactNode} children
 * @param {string|string[]} allowedRoles — если задан, проверяет роль пользователя
 * @param {string} redirectTo — куда перенаправлять при нет доступа (по умолчанию /login)
 */
const ProtectedRoute = ({ children, allowedRoles, redirectTo = '/login' }) => {
    const { isAuthenticated, checked, hasRole } = useAuth();
    const location = useLocation();

    if (!checked) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Загрузка...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to={redirectTo} state={{ from: location }} replace />;
    }

    // Если указаны разрешённые роли — проверяем
    if (allowedRoles && !hasRole(allowedRoles)) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;